import { s3GetObject } from '../utils/awsLib';

function encode(data) {
  const str = data.reduce((a, b) => `${a}${String.fromCharCode(b)}`, '');
  return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
}

export async function getS3Object(key, name, token) {
  const result = await s3GetObject(key, token);
  const body = `data:${result.ContentType};base64,${encode(result.Body)}`;
  return {
    name,
    key,
    body,
    contentType: result.ContentType,
  };
}



// WEBPACK FOOTER //
// ./src/utils/myKadImg.js